import { Box, Card, Stack } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { CraColoringLegend } from "../CraColoring/CraColoringLegend";
import { ToggleVisibilityButton } from "../../ToggleVisibilityButton";
import { MapComponent } from "../../../../project/stores/MapStore";
import { useStores } from "../../../../shared/stores/RootStore";

const MapLegendBase = () => {
  const { mapStore } = useStores();

  return (
    <Card.Root top={2} left={2} position="absolute" zIndex={1}>
      <Stack direction={"row"} minH={"50px"}>
        {mapStore.componentVisibility.legend && (
          <Box py={2} px={3} maxW="200px">
            <CraColoringLegend craColoring={mapStore.craColoring} />
          </Box>
        )}

        <ToggleVisibilityButton
          component={MapComponent.Legend}
          arrowAngleWhenOpen={180}
        />
      </Stack>
    </Card.Root>
  );
};

export const MapLegend = observer(MapLegendBase);
